module.exports = __webpack_public_path__ + "/images/logo-bimbi-megastore-it.e4bee6b.png";